import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.KN7zKn',
    defaultMessage: 'Error',
  },
  message: {
    id: 'studio.OJpqEr',
    defaultMessage: 'An unexpected error has occurred.',
  },
  feedback: {
    id: 'studio.G5YSJR',
    defaultMessage: 'Send feedback',
  },
  toApps: {
    id: 'studio.HPBE7M',
    defaultMessage: 'Back to apps',
  },
});
